<script setup>
import { provide, reactive, ref, nextTick } from "vue";
import FirstSection from "./components/FirstSection.vue";
import Volonter from "./components/Volonter.vue";
import Asistent from "./components/Asistent.vue";

// Reactive objekat za čuvanje podataka
const objekat = reactive({
  firstAndLastName: null,
  dateOfBirth: null,
  placeOfBirth: {
    cityPlaceOfBirth: null,
    countryPlaceOfBirth: null,
  },
  addressInfo: {
    streetAndNumber: null,
    postCode: null,
    typeOfSettlement: null,
    city: null,
  },
  gender: null,
  educationBackground: null,
  profession: null,
  workStatus: null,
  typeOfInvalidity: null,
  diagnosis: null,
  businessAbility: null,
  limitedFunctionality: null,
  // restrictionsInTheArea: [null],
  currentAidsYesNo: null,
  currentAids: null,
  neededAids: null,
  supportOfOtherPerson: null,
  assistanceRequired: null,
  housingConditions: null,
  belongingToMarginalizedGroupsYesNo: null,
  belongingToMarginalizedGroups: null,
  servicesOfMiBoka: null,
  neededServicesOfMiBoka: null,
  identificationNumber: null,
  numberOfDocument: null,
  authorityOfTheDocument: null,
  expirationDateOfTheDocument: null,
  contactInformation: {
    mobilePhone: null,
    landlinePhone: null,
    email: null,
    viber: null,
    homePhoneNumber: null,
    whatsapp: null,
    signal: null,
    telegram: null,
    facebook: null,
  },
  contactPerson: {
    relationship: null,
    firstNameAndSurname: null,
    kinship: null,
    contactPersonPhoneNumber: null,
    landlinePhone: null,
    contactPersonEmail: null,
    contactPersonViber: null,
  },
  rightsOfPersonsWithDisabilities: null,
  foreignLanguagesYesNo: null,
  foreignLanguages: null,
  improveForeignLanguages: null,
  learnForeignLanguages: null,
  workOnComputer: null,
  learnWorkOnComputer: null,
  hobbyYesNo: null,
  hobby: null,
  sportYesNo: null,
  sport: null,
  interestedInParticipating: null,
  createServicesAndPolitics: null,
  timeforActivitiesIMIBoke: null,
  contributeToTheWork: null,
  expectationsOfIMIBoke: null,
  giveConsent: null,
  requestYesNo: null,
  guardianPerson: {
    nameOfGuardianPerson: null,
    identificationNumberofGuardianPerson: null,
    numberOfDocumentofGuardianPerson: null,
    authorityOfTheDocumentofGuardianPerson: null,
    expirationDateOfTheDocumentofGuardianPerson: null,
    addressofGuardianPerson: null,
    cityOfGuardianPerson: null,
  },
  validate: null,
});

// Primenite providere za pristup podacima
provide("objekat", objekat);

// Stanja za prikazivanje sekcija
const showFirstSection = ref(false);
const showVolonter = ref(false);
const showAsistent = ref(false);

const pageContainer = ref(null);
provide("pageContainer", pageContainer);

const showFirst = () => {
  showFirstSection.value = true;
  nextTick(() => {
    if (pageContainer.value) {
      pageContainer.value.scrollTop = 0;
    }
  });
};

// Metoda za prikaz drugog dela
const showVolonterForm = () => {
  showVolonter.value = true;
};

const showAsistentForm = () => {
  showAsistent.value = true;
};

</script>

<template>
  <Toast position="top-center" />
  <div class="forma" ref="pageContainer">
    <div v-if="!showFirstSection && !showVolonter && !showAsistent">
      <h3>
        Postani član/ica (osobe s invaliditetom i/ili članovi/ice porodica osoba
        s invaliditetom u njihovo ime, koji/e imaju prebivalište ili boravište u
        Crnoj Gori).
      </h3>
      <div class="button-container">
        <Button @click="showFirst()" class="sendAnswers">Postani član</Button>
      </div>
    </div>
    <FirstSection v-if="showFirstSection" />
    <div v-if="!showFirstSection && !showVolonter && !showAsistent">
      <h3>
        Postani volonter/ka (osobe bez invaliditeta iz Crne Gore i šire, kao i
        osobe s invaliditetom sa prebivalištem i boravištem van Crne Gore, koje
        žele da doprinesu našem radu na volonterskoj osnovi).
      </h3>
      <div class="button-container">
        <Button @click="showVolonterForm()" class="sendAnswers"
          >Postani volonter</Button
        >
      </div>
    </div>
    <Volonter v-if="showVolonter" />
    <div v-if="!showFirstSection && !showVolonter && !showAsistent">
      <h3>
        Postani personalni/a asistent/kinja i/ili asistent/kinja u kući
        (osobe koje žele da pružaju podršku osobama s invaliditetom).
      </h3>
      <div class="button-container">
        <Button @click="showAsistentForm()" class="sendAnswers"
          >Postani asistent/kinja</Button
        >
      </div>
    </div>
    <Asistent v-if="showAsistent" />
  </div>
</template>
